exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Montserrat:100,100i,200,200i,300,300i,400,400i,500,500i,600,600i,700,700i,800,800i,900,900i);", ""]);

// module
exports.push([module.id, ".main {\n  display: flex;\n  justify-content: inherit;\n  align-items: inherit;\n  flex-wrap: inherit;\n  flex-direction: column;\n  min-height: 100vh;\n  position: relative; }\n\n.center-value {\n  width: 100%;\n  text-align: center; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/app/containers/Main/Main.scss
// module id = 778
// module chunks = 0